const users = {
  admin: {
    username: 'admin',
    password: '1111',
    token: 'admin_token'
  }
}

export { users }
